class EditGatewayMembersAndGroupsDatatable {
    constructor(gatewayID, numberOfMembers, numberOfGroups){
        let organizationID = new URLSearchParams(window.location.search).get('organizationID');
        this.organizationID = organizationID;
        this.gatewayID = gatewayID;
        this.form = document.getElementById('frm-generalForms-editGatewayForm-editGatewayForm');
        this.jQueryForm = $(this.form);
        this.modal = document.getElementById('edit_gateway_modal');
        this.addMembersModal = document.getElementById('add_members_to_gateway_modal');
        this.datatableElement = this.jQueryForm.find('#edit-gateway-members');

        this.datatable = this.init(this.datatableElement, organizationID, gatewayID, numberOfMembers, numberOfGroups);
        this.initActions(organizationID);
    }
    init(el, organizationID, gatewayID, numberOfMembers, numberOfGroups){
        const thisClass = this;
        /** Add loading for the whole edit members tab */
        const blockUI = new KTBlockUI(this.modal.querySelector('#allowed_for_tab'), {
            overlayClass: "ga-bg-primary-050",
        });
        blockUI.block();

        let data = {
            organizationID: organizationID,
            gatewayID: gatewayID
        };
        const datatable =  el.DataTable({
            searchDelay: 500,
            processing: false,
            serverSide: false,
            stateSave: false,
            sortable: false,
            info: false,
            ordering: false,
            paging: false,
            ajax: {
                url: '/gateways/?do=getMembersGateway',
                type: 'GET',
                data: data
            },
            select: {
                style: 'multi',
                selector: 'td:first-child input[type="checkbox"]',
                className: ''
            },
            language: {
                emptyTable: "No data found",
                loadingRecords: ""
            },
            drawCallback: function (settings) {
                // Init all popovers after datatable draw
                const popoverTriggerList = [].slice.call(document.querySelectorAll('#edit-gateway-members_wrapper [data-bs-toggle="popover"]'));
                popoverTriggerList.map(function (popoverTriggerEl) {
                    new bootstrap.Popover(popoverTriggerEl);
                });
                /** Remove header of table */
                thisClass.jQueryForm.find("#edit-gateway-members_wrapper .dataTables_scrollHead, #edit-gateway-members_wrapper thead").remove();

                /** Set rows to section (groups/members) */
                const api = this.api();
                const rows = api.rows({
                    page: "current"
                }).nodes();
                let lastData = null;

                api.column(0, {
                    page: "current"
                }).data().each(function(uuid, i) {
                    let rowSectionName = api.rows(i).data().toArray()[0]['isMember'] ? 'Members' : 'Groups';
                    if(rowSectionName !== lastData){
                        lastData = rowSectionName;
                        let className = rowSectionName === 'Members' ? 'members' : 'groups';
                        let selected = rowSectionName === 'Members' ? numberOfMembers : numberOfGroups;
                        $(rows).eq(i).before(
                            "<tr class=\"section fs-5 fw-bolder border-0"+(selected > 0 ? '' : ' d-none')+"\" data-section-name=\""+className+"\">" +
                            "   <td class=\"py-1 d-none\"></td>" +
                            "   <td class=\"py-1\">" + lastData +
                            "       <span class=\"badge badge-sm badge-light-primary align-middle ms-1\">" +
                            "           <span id=\"gateway_"+className+"_selected\">" + selected + "</span>" +
                            "       </span>" +
                            "   </td>" +
                            "   <td class=\"py-1 text-end\">" +
                            "       <span class=\"text-decoration-underline-ga text-danger danger fs-7 remove-all-"+className+"-from-gateway\">Remove All</span>" +
                            "   </td>" +
                            "</tr>"
                        );
                    }
                });
            },
            createdRow: function (row, data) {
                /** Add classes to row for easy count number of members/groups */
                if (data.isMember) {
                    $(row).addClass('is-member');
                } else {
                    $(row).addClass('is-group');
                }
                /** Hide member/group that is not in gateway */
                if (!data.checked) {
                    $(row).addClass('d-none not-in-gateway');
                }
            },
            columns: [
                {
                    data: 'uuid',
                    className: 'd-none',
                    sortable: false,
                    render: function (data, type, row) {
                        if (row['isMember']) {
                            return '<div class="form-check form-check-sm form-check-custom form-check-solid ga-border-primary-200 mx-3 fv-row">' +
                                '    <input class="form-check-input cursor-pointer" type="checkbox" name="members[]" value="' + row['uuid'] + '" ' + (row['checked'] ? 'checked' : '') + '/>' +
                                '</div>';
                        } else {
                            return '<div class="form-check form-check-sm form-check-custom form-check-solid ga-border-primary-200 mx-3 fv-row">' +
                                '    <input class="form-check-input cursor-pointer" type="checkbox" name="groups[]" value="' + row['uuid'] + '" ' + (row['checked'] ? 'checked' : '') + '/>' +
                                '</div>';
                        }
                    }
                },
                {
                    data: 'name',
                    title: 'Member / Group',
                    sortable: false,
                    className: 'min-w-120px',
                    render: function (data, type, row) {
                        if (row['isMember']) {
                            return new MemberInfoGenerator(row).generateTableMember();
                        } else {
                            return new GroupInfoGenerator().generateMemberTableView(row['name'], row['edit'], row['uuid'], row['numberOfMembers']);
                        }
                    }
                },
                {
                    data: null,
                    title: 'Action',
                    sortable: false,
                    className: 'text-end w-75px',
                    render: function (data, type, row) {
                        return '<span class="text-decoration-underline-ga text-danger danger fs-7 remove-member-from-gateway">Remove</span>';
                    }
                }
            ]
        }).on('init.dt', function () {
            /** Remove modal loading - everything is set */
            blockUI.release();

            if (numberOfMembers + numberOfGroups === 0) {
                thisClass.jQueryForm.find('#edit-gateway-members_wrapper').hide();
                thisClass.jQueryForm.find('#edit-gateway-members_no-results').addClass('d-flex flex-center flex-column').removeClass('d-none');
                thisClass.jQueryForm.find('#edit-gateway-members-alert').addClass('d-none');
                thisClass.jQueryForm.find('[data-kt-docs-table-filter="search-parent"]').addClass('d-none');
            } else {
                thisClass.jQueryForm.find('#edit-gateway-members-alert').removeClass('d-none');
            }

            /** If all members/groups is in gateway - disable button for add members/groups to gateway */
            let membersOrGroupsNotInGateway = datatable.rows('.not-in-gateway.d-none').data().toArray();
            let addMembersToGatewayButton = thisClass.modal.querySelector('#addMembersToGateway');
            if(membersOrGroupsNotInGateway.length === 0){
                addMembersToGatewayButton.setAttribute('disabled', 'true');
            }

            /** If user close add modal - show create/edit gateway modal */
            thisClass.addMembersModal.addEventListener('hide.bs.modal', function (event) {
                bootstrap.Modal.getOrCreateInstance(thisClass.modal, {}).show();
            })

            /** Init add and remove actions from members */
            thisClass.initAddMembersOrGroupsToGateway();
            thisClass.removeMemberOrGroupFromGateway();

            /** Adjust datatable columns */
            thisClass.adjustDatatable();

            /** Init validation for add members/groups to datatable */
            thisClass.addMembersOrGroupToGatewayFormValidation();
        });
        return datatable;
    }
    addMembersOrGroupToGatewayFormValidation(){
        let thisClass = this;
        let submitButton = this.addMembersModal.querySelector('.add-button');
        let form = thisClass.addMembersModal.closest('form');

        let validator = FormValidation.formValidation(form,
            {
                fields: {
                    'membersOrGroupsToAdd': {
                        validators: {
                            notEmpty: {
                                message: 'This field is required'
                            },
                        }
                    },
                },
                plugins: {
                    trigger: new FormValidation.plugins.Trigger(),
                    autoFocus: new FormValidation.plugins.AutoFocus(),
                    bootstrap: new FormValidation.plugins.Bootstrap5({
                        rowSelector: '.fv-row',
                        eleInvalidClass: '',
                        eleValidClass: ''
                    }),
                }
            }
        );

        const submitForm = () => {
            if (validator) {
                validator.validate().then(function (status) {
                    if (status === 'Valid') {
                        new DismissModal(thisClass.addMembersModal.id).disable();
                        submitButton.setAttribute('data-kt-indicator', 'on');
                        submitButton.disabled = true;

                        let selectedMembersOrGroups = JSON.parse($('#'+thisClass.addMembersModal.id+' input[name=membersOrGroupsToAdd]').val());
                        for (const i in selectedMembersOrGroups) {
                            if(selectedMembersOrGroups[i]['uuid']){
                                let tableRowInput = thisClass.datatableElement.find('input[value='+selectedMembersOrGroups[i]['uuid']+']');
                                if(tableRowInput){
                                    tableRowInput.prop('checked', true);
                                    tableRowInput.closest('tr').removeClass('d-none not-in-gateway');
                                }
                            }
                        }
                        thisClass.afterAddOrRemoveEvents();

                        bootstrap.Modal.getOrCreateInstance(thisClass.addMembersModal).hide();
                        bootstrap.Modal.getOrCreateInstance(thisClass.modal, {}).show();
                        submitButton.setAttribute('data-kt-indicator', 'off');
                        submitButton.disabled = false;
                        new DismissModal(thisClass.addMembersModal.id).enable();
                        KTSticky.createInstances();
                    }
                });
            }
        }

        submitButton.addEventListener('click', function (e) {
            // Prevent default button action
            e.preventDefault();
            // Validate form before submit
            submitForm();
        });

        form.addEventListener("submit", function(e) {
            // Prevent default button action
            e.preventDefault();
            // Validate form before submit
            submitForm();
        }, true);
    }
    initAddMembersOrGroupsToGateway(){
        let thisClass = this;
        let addMembersToGatewayButton = this.modal.querySelector('#addMembersToGateway');

        /** After click on add members/groups to gateway */
        addMembersToGatewayButton.addEventListener('click', function () {
            /** initialize tagify input for adding members/groups to gateway */
            let membersOrGroupsNotInGateway = thisClass.datatableElement.DataTable().rows('.not-in-gateway.d-none').data().toArray();
            thisClass.initAddMembersOrGroupToGatewayTagify(membersOrGroupsNotInGateway);

            /** Open add members or groups modal */
            bootstrap.Modal.getOrCreateInstance(thisClass.modal).hide();
            bootstrap.Modal.getOrCreateInstance(thisClass.addMembersModal, {}).show();
        });
    }
    initAddMembersOrGroupToGatewayTagify(membersOrGroupsNotInGateway){
        const inputElm = this.addMembersModal.querySelector('input[name=membersOrGroupsToAdd]');
        /** Destroy tagify on input - we want new instance if tagify already exist */
        if(inputElm.__tagify){
            inputElm.value = '';
            inputElm.__tagify.destroy();
        }

        /** Adding values - tagify needs 'value' */
        for(let i in membersOrGroupsNotInGateway){
            membersOrGroupsNotInGateway[i]['value'] = membersOrGroupsNotInGateway[i]['uuid'];
        }
        /** Initialize tagify input for adding members or groups */
        new MembersGroupsTagify(inputElm, membersOrGroupsNotInGateway);
    }
    adjustDatatable(){
        const thisClass = this;
        /** Adjust datatable columns after modal is hidden */
        this.addMembersModal.addEventListener('hidden.bs.modal', function () {
            thisClass.datatableElement.DataTable().columns.adjust();
        });
    }
    initActions(){
        const thisClass = this;
        /** Search */
        let timer;
        const input = this.form.querySelector('input[data-kt-docs-table-filter=search]');
        //Add event to search input
        if(input){
            input.addEventListener('keyup', function (e) {
                clearTimeout(timer);
                timer = setTimeout(() => {
                    thisClass.searchDatatable(this.value.toLowerCase());
                }, 300);
            });
        }
    }
    removeMemberOrGroupFromGateway(){
        const thisClass = this;
        let removeMemberButtons = $(thisClass.datatableElement).find('.remove-member-from-gateway');
        removeMemberButtons.on('click', function() {
            let row = $(this).closest('tr');
            if(row.find('input[name=members\\[\\]]').length === 1){
                row.find('input[name=members\\[\\]]').prop('checked', false);
            } else {
                row.find('input[name=groups\\[\\]]').prop('checked', false);
            }
            row.addClass('d-none not-in-gateway');
            thisClass.afterAddOrRemoveEvents();
        });
        let removeAllMembersButtons = $(thisClass.datatableElement).find('.remove-all-members-from-gateway');
        removeAllMembersButtons.on('click', function() {
            let inputs = $(thisClass.form).find('tr input[name=members\\[\\]]');
            for (let i = 0; i < inputs.length; i++) {
                let row = $(inputs[i]).closest('tr');
                $(inputs[i]).prop('checked', false);
                row.addClass('d-none not-in-gateway');
            }
            thisClass.afterAddOrRemoveEvents();
        });
        let removeAllGroupsButtons = $(thisClass.datatableElement).find('.remove-all-groups-from-gateway');
        removeAllGroupsButtons.on('click', function() {
            let inputs = $(thisClass.form).find('tr input[name=groups\\[\\]]');
            for (let i = 0; i < inputs.length; i++) {
                let row = $(inputs[i]).closest('tr');
                $(inputs[i]).prop('checked', false);
                row.addClass('d-none not-in-gateway');
            }
            thisClass.afterAddOrRemoveEvents();
        });
    }
    afterAddOrRemoveEvents(){
        let membersNotInGateway = this.datatable.rows('.not-in-gateway.d-none.is-member').data().toArray();
        let groupsNotInGateway = this.datatable.rows('.not-in-gateway.d-none.is-group').data().toArray();
        let membersInGateway = this.datatable.rows(':not(.not-in-gateway.d-none).is-member').data().toArray();
        let groupsInGateway = this.datatable.rows(':not(.not-in-gateway.d-none).is-group').data().toArray();

        this.datatableElement.find('#gateway_members_selected').text(membersInGateway.length);
        this.datatableElement.find('#gateway_groups_selected').text(groupsInGateway.length);

        let addMembersToGatewayButton = this.form.querySelector('#addMembersToGateway');
        if((membersNotInGateway.length + groupsNotInGateway.length) === 0){
            addMembersToGatewayButton.setAttribute('disabled', 'true');
        } else {
            addMembersToGatewayButton.removeAttribute('disabled');
        }

        if(membersInGateway.length === 0){
            this.datatableElement.find('tr[data-section-name=members]').addClass('d-none');
        } else {
            this.datatableElement.find('tr[data-section-name=members]').removeClass('d-none');
        }
        if(groupsInGateway.length === 0){
            this.datatableElement.find('tr[data-section-name=groups]').addClass('d-none');
        } else {
            this.datatableElement.find('tr[data-section-name=groups]').removeClass('d-none');
        }

        if((membersInGateway.length + groupsInGateway.length) === 0){
            this.jQueryForm.find('#edit-gateway-members_wrapper').hide();
            this.jQueryForm.find('#edit-gateway-members_no-results').addClass('d-flex flex-center flex-column').removeClass('d-none');
            this.jQueryForm.find('#edit-gateway-members-alert').addClass('d-none');
            this.jQueryForm.find('[data-kt-docs-table-filter="search-parent"]').addClass('d-none');
        } else {
            this.jQueryForm.find('#edit-gateway-members_wrapper').show();
            this.jQueryForm.find('#edit-gateway-members_no-results').removeClass('d-flex flex-center flex-column').addClass('d-none');
            this.jQueryForm.find('#edit-gateway-members-alert').removeClass('d-none');
            this.jQueryForm.find('[data-kt-docs-table-filter="search-parent"]').removeClass('d-none');
        }
    }
    searchDatatable(value) {
        /** Search only visible (selected) members */
        let data = this.datatable.rows().data().toArray();
        let groupsInGateway = 0;
        let membersInGateway = 0;
        for(let i in data){
            let node = $(this.datatable.row(i).node());
            if(!node.hasClass('not-in-gateway')){
                if(value === '' || this.includeValue(data[i].name, value) || (data[i].isMember && (this.includeValue(data[i].username, value) || this.includeValue(data[i].managerRole, value)))){
                    node.removeClass('d-none');
                    if(node.hasClass('is-member')){
                        membersInGateway++;
                    } else {
                        groupsInGateway++;
                    }
                } else {
                    node.addClass('d-none');
                }
            }
        }

        if(groupsInGateway > 0){
            this.datatableElement.find('[data-section-name="groups"]').removeClass('d-none');
        } else {
            this.datatableElement.find('[data-section-name="groups"]').addClass('d-none');
        }
        if(membersInGateway > 0){
            this.datatableElement.find('[data-section-name="members"]').removeClass('d-none');
        } else {
            this.datatableElement.find('[data-section-name="members"]').addClass('d-none');
        }

        if((groupsInGateway + membersInGateway) === 0){
            this.jQueryForm.find('#edit-gateway-members_no-search-results').removeClass('d-none');
        } else {
            this.jQueryForm.find('#edit-gateway-members_no-search-results').addClass('d-none');
        }
    }
    includeValue(value, search) {
        if(value !== '' && value !== null){
            return value.toLowerCase().includes(search);
        }
        return false;
    }
}
window.EditGatewayMembersAndGroupsDatatable = EditGatewayMembersAndGroupsDatatable;